const features = [
  {
    icon: "ri-shield-check-line",
    title: "Advanced Security",
    description:
      "Our applications implement industry-leading encryption standards and security protocols to keep your data safe from threats and unauthorized access.",
    accent: "emerald",
    tag: "SECURITY",
  },
  {
    icon: "ri-speed-line",
    title: "Lightning Performance",
    description:
      "Engineered for speed and efficiency, our apps are optimized to run smoothly on all iOS devices without draining battery or consuming excessive resources.",
    accent: "amber",
    tag: "PERFORMANCE",
  },
  {
    icon: "ri-eye-off-line",
    title: "Complete Privacy",
    description:
      "We believe your data belongs to you. Our zero-log policy and privacy-first architecture ensure your personal information is never collected or shared.",
    accent: "rose",
    tag: "PRIVACY",
  },
  {
    icon: "ri-smartphone-line",
    title: "Native iOS Design",
    description:
      "Every interface is crafted following Apple's Human Interface Guidelines, delivering a seamless, intuitive experience that feels right at home on iOS.",
    accent: "sky",
    tag: "DESIGN",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Dedicated Support",
    description:
      "Our expert team is always available to assist users with any questions or issues, ensuring a smooth and satisfying experience with every product.",
    accent: "violet",
    tag: "SUPPORT",
  },
  {
    icon: "ri-refresh-line",
    title: "Regular Updates",
    description:
      "We continuously improve our applications with new features, performance enhancements, and security patches to stay ahead of the evolving mobile landscape.",
    accent: "teal",
    tag: "UPDATES",
  },
];

const accentMap: Record<string, { bg: string; border: string; text: string; badge: string }> = {
  emerald: { bg: "bg-emerald-400/10", border: "border-emerald-400/20", text: "text-emerald-400", badge: "bg-emerald-400/10 text-emerald-400" },
  amber: { bg: "bg-amber-400/10", border: "border-amber-400/20", text: "text-amber-400", badge: "bg-amber-400/10 text-amber-400" },
  rose: { bg: "bg-rose-400/10", border: "border-rose-400/20", text: "text-rose-400", badge: "bg-rose-400/10 text-rose-400" },
  sky: { bg: "bg-sky-400/10", border: "border-sky-400/20", text: "text-sky-400", badge: "bg-sky-400/10 text-sky-400" },
  violet: { bg: "bg-violet-400/10", border: "border-violet-400/20", text: "text-violet-400", badge: "bg-violet-400/10 text-violet-400" },
  teal: { bg: "bg-teal-400/10", border: "border-teal-400/20", text: "text-teal-400", badge: "bg-teal-400/10 text-teal-400" },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-[#F7F6F3] py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Why Choose Us</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#1A1A1A] leading-tight font-['Space_Grotesk']">
              What Makes<br />
              <span className="text-[#1A1A1A]/30">Our Apps</span><br />
              Different.
            </h2>
          </div>
          <p className="text-[#666] text-base leading-relaxed max-w-sm lg:text-right">
            Every feature is thoughtfully designed to deliver real value to iOS users around the world.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat) => {
            const a = accentMap[feat.accent];
            return (
              <div
                key={feat.title}
                className="bg-white rounded-2xl p-7 border border-[#E8E6E0] flex flex-col gap-4 hover:border-[#D0CEC8] transition-colors duration-200"
              >
                <div className="flex items-start justify-between">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${a.bg} border ${a.border}`}>
                    <i className={`${feat.icon} ${a.text} text-xl`} />
                  </div>
                  <span className={`text-[10px] font-bold tracking-widest px-2.5 py-1 rounded-full ${a.badge}`}>
                    {feat.tag}
                  </span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#1A1A1A] mb-2 font-['Space_Grotesk']">{feat.title}</h3>
                  <p className="text-[#777] text-sm leading-relaxed">{feat.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
